const windowAvailable = () => typeof window !== "undefined";

export default windowAvailable
